export const isDenebEnabled = process.env.NEXT_PUBLIC_BUILD_TARGET === 'deneb'
